module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Db-Ec.12c2c0f4.png";